function isSessionStorageAvailable() {
    const testValue = 'test';

    try {
        sessionStorage.setItem('testValue', testValue);
        sessionStorage.removeItem('testValue');
    } catch (error) {
        return false;
    }

    return true;
}

export default isSessionStorageAvailable;
